import Context from './context';
import { LocaledComponentProps, useLocale } from './hooks';
import { LocaleType } from './lang/type';
import LocaleProvider from './provider';
import withLocale from './with-locale';
export { LocaleProvider, useLocale, withLocale, LocaledComponentProps, Context, LocaleType };
export default LocaleProvider;
